export const getValueDynamics = (value: number) =>
  value > 0 ? 'positive' : (value < 0 ? 'negative' : null)
